import './DadosBancario.css';
import { useState } from 'react';
import { useCookies } from "react-cookie";
import { useNavigate } from 'react-router-dom'
import EtapaDadosBancario from '../../Banners/EtapaDadosBancario/EtapaDadosBancario'
import BannerDadosBancariosPhone from '../../Banners/BannerDadosBancariosPhone/BannerDadosBancariosPhone.js'
import Input from '../../Input/input';
import Button from '../../Button/button';
import axios from 'axios';
import api from '../../../services/api.js';
import Loading from '../../Loading/Loading.js'

const optBanco = [
    { value: '', text: 'Selecione' },
    { value: '001', text: '001 - Banco do Brasil' },
    { value: '033', text: '033 - Santander' },
    { value: '041', text: '041 - Banrisul' },
    { value: '074', text: '074 - Safra' },
    { value: '104', text: '104 - Caixa Econômica Federal' },
    { value: '237', text: '237 - Bradesco' },
    { value: '318', text: '318 - BMG S.A' },
    { value: '341', text: '341 - Itaú' },
    { value: '748', text: '748 - Sicredi' },
    { value: '756', text: '756 - Sicoob' }
]



function DadosBancario() {
    // console.log(window)
    const [ww, setW] = useState(window.screen.width);
    const [hh, setH] = useState(window.screen.height);

    const [tipoConta2, setTipoConta] = useState("CC");
    const [selectedBanco, setSelectedBanco] = useState(optBanco[0].value);
    const encode_data = sessionStorage.getItem("encode_data")
    const [isShow, setShow] = useState(false);

    const handleChangeBanco = event => {
        setSelectedBanco(event.target.value);
    };

    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]);
    const [isChecked, setIsChecked] = useState(true)
    const [payload, setPayload] = useState([]);
    const navigate = useNavigate();



    const payloadSended = sessionStorage.getItem("payloadSendedEndereco")

    const payload_value = sessionStorage.getItem("payload_value");
    const payload_first_name = sessionStorage.getItem("payload_first_name");
    const payload_last_name = sessionStorage.getItem("payload_last_name");
    const payload_phone = sessionStorage.getItem("payload_phone");
    const payload_email = sessionStorage.getItem("payload_email");


    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {
                const [key, value] = rawParam.split("=");
                if (key === 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {
                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }
        return {};
    }

    let buttonContinuar = document.querySelector(".btnContinuar");
    let btnContinuar = "btnContinuar"
    let btnVoltar = "btnVoltar"
    async function handleSubmit(e) {
        e.preventDefault();
        const errors = handleOnBlur(payload, "submit");

        if (errors.length === 0) {
            const banco = document.getElementById("banco");
            const bancoEle = banco.value;

            const dadosBancarios = {                            
                banco: bancoEle,
                agencia_num: payload.numeroAgencia,
                tipoConta: tipoConta2,
                conta_digito: payload.digito,
                conta_num: payload.numeroConta
            }
          

            const cookieParams = convertCookie(cookies.__gtm_campaign_url);
            const sendbackend = {
                dadosBancarios,

                utm_campaign: (cookieParams.utm_campaign || ""),
                utm_medium: (cookieParams.utm_medium || ""),
                utm_source: (cookieParams.utm_source || ""),
                utm_id: (cookieParams.utm_id || ""),
                utm_content: (cookieParams.utm_content || ""),
                utm_term: (cookieParams.utm_term || ""),
                gclid: (cookieParams.gclid || ""),
                fbclid: (cookieParams.fbclid || ""),
                aff_click_id: (cookieParams.aff_click_id || ""),
            }
            
            const JsonArray = JSON.stringify(sendbackend)
            const json_obj = JSON.parse(JsonArray)

            console.log(json_obj);

            setShow(true);

            api.put(`/crefaz/update/${encode_data}`, json_obj, {

            }).then((response) => {

                    const encode = response.data.encode_data
                    const id = response.data.id
                    sessionStorage.setItem("encode_data", encode);
                    sessionStorage.setItem("id", id);


                    api.put(`/crefaz/finalizarProposta/${encode_data}`, {

                    }).then((response) => {
                        console.log("finalizar proposta: ", response.data.cod_erro)

                        window.dataLayer.push({ "event": "contrato-gerado",
                            "value": payload_value,
                            "first_name": payload_first_name,
                            "last_name": payload_last_name, 
                            "phone": payload_phone, 
                            "email": payload_email
                        });

                        if(response.data.cod_erro == 7) {    
                            navigate("/contato")
                        } else{
                            setShow(false);
                            navigate("/informacoes")
                        }
                    })
                    .catch(() => {
                        console.log("erro")
                    })
                })
                .catch(() => {
                    console.log("erro")
                    navigate("/contato")
                    setShow(false);
                    buttonContinuar.disabled = false;
                })


                
        } 
    }
    const handleOnBlur = (e, prop) => {
        const errors = [];

        if ((prop === "numeroAgencia" && !e?.target?.value) || (prop === "submit" && !e?.numeroAgencia)) {
            errors.push({
                prop: "numeroAgencia",
                errorMessage: "Insira o número da agência"
            })
        }
       
        if ((prop === "numeroConta" && !e?.target?.value) || (prop === "submit" && !e?.numeroConta)) {
            errors.push({
                prop: "numeroConta",
                errorMessage: "Insira o número da sua conta"
            })
        }

        if ((prop === "digito" && !e?.target?.value) || (prop === "submit" && !e?.digito)) {
            errors.push({
                prop: "digito",
                errorMessage: "Insira o dígito da sua conta"
            })
        }
       
        setFieldsValidity(errors)

        return errors;
    }

    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }


    function selTipoConta(tipo){
        alert(tipo);
    }

    return (
        <div className="home">
            <div className='mobile'>{isShow && <Loading />}</div>
            <EtapaDadosBancario />
            <BannerDadosBancariosPhone />
            <form
                className='container2'
                onSubmit={handleSubmit}
            >

                {/* <div className='resolucao'>{ww}px X {hh}</div> */}


                <div className='form'>
                    <div className='titleform'>
                        <h4 className='titleMob'>Dados Bancários</h4>
                    </div>

                    <div className='spaceform'></div>
                    <div className='group'>
                        <label className='label'><b>Banco</b></label>
                        <div className="cmpSelect">
                            <select 
                                id="banco"
                                name="banco"
                                className="selSel"
                                value={selectedBanco}
                                onChange={handleChangeBanco}
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}>
                                {
                                    optBanco.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    
                    <div className='spaceform'></div>

                    <div className='Input-form'>
                        <div className=''>
                            <div className=''>
                                <label className='label'><b>Tipo de Conta</b></label>
                                <div className="inputRadio lfLeft">
                                    <label for="lb1">Corrente</label>
                                    <input type="radio" value="corrente" name="tipoConta" id="lb1" checked="true" onClick={() => setTipoConta("CC")} />
                                </div>

                                <div className="inputRadio lfRight">
                                    <label for="lb2">Poupança</label>
                                    <input type="radio" value="poupanca" name="tipoConta" id="lb2" onClick={() => setTipoConta("CP")} />
                                </div>
                            </div>
                        </div>

                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>Número da agência</b> (sem dígito)</label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "numeroAgencia")}
                                value={payload.numeroAgencia}
                                name="numeroAgencia"
                                type="text"
                                placeholder='Número Agência'
                                length="9"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                        </div>

                        <div className='spaceform'></div>
                        <div className=''>            
                            <div className="bloco60 lfLeft">
                                <label className='label'><b>Número da conta</b></label>
                                <Input
                                    onChange={(e) => handleChangeInputs(e.target.value, "numeroConta")}
                                    value={payload.numeroConta}
                                    name="numeroConta"
                                    type="text"
                                    placeholder='Número da Conta'
                                    length="9"
                                    error={fieldsValidity}
                                    handleOnBlur={handleOnBlur}
                                />
                            </div>

                            <div className="bloco40 lfRight">
                                <label className='label'><b>Dígito</b></label>
                                <Input
                                    onChange={(e) => handleChangeInputs(e.target.value, "digito")}
                                    value={payload.digito}
                                    name="digito"
                                    type="text"
                                    placeholder='Número'
                                    length="2"
                                    error={fieldsValidity}
                                    handleOnBlur={handleOnBlur}
                                />
                            </div>
                        </div>
                        <div className='spaceform'></div>

                        <div className='spaceform'></div>

                        <Button
                            message='CONTINUAR'
                            className={btnContinuar}
                            isChecked={isChecked}
                        />

                        <button
                            className={btnVoltar}
                            cursor='pointer'
                            onClick={() => navigate("/endereco")}>
                            VOLTAR
                        </button>

                        <div className='space1'></div>
                    </div>
                </div>
            </form >
        </div >
    );
}

export default DadosBancario;